<!-- 头部 -->
<template>
    <div class="headerSty">
      <div class="headerBox">
        <div class="logoBox">
            <div class="logo">
              <img :src="imgUrl + logoImg" alt="">
            </div>
            <p class="logoName">{{logoName}}</p>
        </div> 
        <div class="userBox">
            <div class="user cursor" @click="goUser" v-if="loginSta">
              <div class="userHead">
                  <img v-if="userInfo.avatar" :src="imgUrl + userInfo.avatar" alt="">
                  <img v-else :src="imgUrl + logoImg" alt="">
              </div>
              <p>{{userInfo.nickname}}</p>
              <el-popover
                placement="bottom"
                title=""
                width="100"
                trigger="hover"
                content="">
                <div class="jianBox" slot="reference" style="width: 20px;height: 20px;">
                  <img src="../src/assets/icon/jian.png" alt="" style="width: 20px;height: 20px;">
                </div>
                <div @click="goOut" class="cursor" style="display: flex;align-items: center;justify-content: center;font-size: 14px;line-height: 1;padding: 30px 0 20px;border: 1px solid #EBEEF5;box-shadow: 0 2px 0.75rem 0 rgba(0, 0, 0, .1)">
                  <i class="el-icon-switch-button" style="margin-right: 10px;font-size: 18px;"></i>
                  退出登录
                </div>
              </el-popover>
            </div> 
            <div class="userNull cursor" @click="goLogin" v-else>
              <div class="null">
                  <img src="../src/assets/icon/nullhead.png" alt="">
              </div>
              <p>未登录</p>
            </div>
            <p class="timer">{{$method.getTodayFormatted()}}</p>
        </div>
      </div>
    </div>
</template>
<script>
  export default {
    name: "headerBox",
    components: {},
    data() {
      return {
        userInfo:{},
        loginSta:false
      };
    },
    computed: {
      imgUrl(){
        return this.$store.state.imgUrl;
      },
      logoImg(){
        return this.$store.state.logoImg;
      },
      logoName(){
        return this.$store.state.logoName;
      }
    },
    methods: {
      // 去登录
      goLogin(){
        this.$router.push('/login');
      },
      // 个人信息
      goUser(){
        this.$router.push('/usercenter');
      },
      // 退出登录
      goOut(){
        window.localStorage.clear();
        this.$router.replace({ path: '/login' });
      }
    },
    created() {
    },
    beforeMount() {},
    mounted() {
      this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
      if(window.localStorage.getItem("token")){
        this.loginSta = true;
      }else{
        this.loginSta = true;
      }
    },
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {}, 
    destroyed() {}, 
    activated() {
      
    }, 
    deactivated() {}, 
  };
  </script>
  <style lang="less" scoped>
    .headerSty{
      width: 100vw;
      height: 80px;
    }
    .headerBox{
      width: 100vw;
      height: 80px;
      background: #5CC971;
      padding: 0 30px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
      .logoBox{
        display: flex;
        align-items: center;
        .logo{
          width: 50px;
          height: 46.17px;
          margin-right: 12px;
          img{
            width: 50px;
            height: 46.17px;
          }
        }
        .logoName{
          color: #FFFFFF;
          font-size: 36px;
          font-weight: bold;
        }
      }
      .userBox{
        display: flex;
        align-items: center;
        .userNull{
          display: flex;
          align-items: center;
          color: #FFFFFF;
          font-size: 20px;
          .null{
            width: 50px;
            height: 50px;
            box-sizing: border-box;
            border: 2px solid #FFFFFF;
            margin-right: 12px;
            border-radius: 50%;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #E4E4E4;
            img{
              width: 24px;
              height: 24px;
            }
          }
        }
        .user{
          display: flex;
          align-items: center;
          color: #FFFFFF;
          font-size: 20px;
          .userHead{
            width: 50px;
            height: 50px;
            box-sizing: border-box;
            border: 2px solid #FFFFFF;
            margin-right: 12px;
            border-radius: 50%;
            overflow: hidden;
            img{
              width: 50px;
              height: 50px;
            }
          }
        }
        
        .timer{
          font-size: 18px;
          color: #FFFFFF;
          margin-left: 30px;
        }
      }
    }
  </style>